/* eslint-disable import/prefer-default-export */
export const ADMIN_EMAIL = '_re@orphic.ca';
export const PHONE_REGEX_P = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
